<div class="project-display-container" *ngIf="currentItem">
  <div class="readonly-notice">
    <mat-icon>info</mat-icon>
    <span>{{ 'work_inspection_project_readonly_notice' | translate }}</span>
  </div>

  <h3>{{ 'common_section_identification' | translate }}</h3>
  <mat-card class="info-card">
    <mat-grid-list cols="10" rowHeight="50px" gutterSize="20px">
      <mat-grid-tile colspan="2">
        <div class="info-field">
          <label class="info-label">{{ 'common_field_code' | translate }}</label>
          <p class="info-value">{{ currentItem.code }}</p>
        </div>
      </mat-grid-tile>
      <mat-grid-tile colspan="3">
        <div class="info-field">
          <label class="info-label">{{ 'common_field_label' | translate }}</label>
          <p class="info-value">{{ currentItem.displayName }}</p>
        </div>
      </mat-grid-tile>
      <mat-grid-tile colspan="3">
        <div class="info-field">
          <label class="info-label">{{ 'common_field_owner' | translate }}</label>
          <p class="info-value">{{ currentItem.owner || ('common_na' | translate) }}</p>
        </div>
      </mat-grid-tile>
      <mat-grid-tile colspan="2">
        <div class="info-field">
          <label class="info-label">{{ 'common_field_creator' | translate }}</label>
          <p class="info-value">{{ currentItem.creator || ('common_na' | translate) }}</p>
        </div>
      </mat-grid-tile>
      <mat-grid-tile colspan="2" *ngIf="currentItem?.workInspectionId && currentItem?.createDate">
        <div class="info-field">
          <label class="info-label">{{ 'project_field_creation_date' | translate }}</label>
          <p class="info-value">{{ currentItem.createDate | localizedDate: 'shortDate' }}</p>
        </div>
      </mat-grid-tile>
      <mat-grid-tile colspan="2" *ngIf="currentItem?.workInspectionId && currentItem?.updateDate && currentItem?.updateDate !== currentItem?.createDate">
        <div class="info-field">
          <label class="info-label">{{ 'project_field_last_modification_date' | translate }}</label>
          <p class="info-value">{{ currentItem.updateDate | localizedDate: 'shortDate' }}</p>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-card>

  <div class="row">
    <div class="col-6">
      <div class="title-margin-top">
        <h3>{{ 'work_inspection_project_db_version_frozen' | translate }}</h3>
        <mat-card class="info-card">
          <div class="info-field">
            <label class="info-label">{{ 'work_inspection_project_version' | translate }}</label>
            <p class="info-value">{{ currentItem.versionName || currentItem.versionId || 'N/A' }}</p>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <div class="title-margin-top">
        <h3>{{ 'project_section_project_nature' | translate }}</h3>
        <mat-card class="info-card">
          <div class="info-field">
            <label class="info-label">{{ 'ref_field_project_type' | translate }}</label>
            <p class="info-value">{{ projectTypesDisplay }}</p>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="col-6">
      <div class="title-margin-top">
        <h3>{{ 'project_section_water_biodiversity' | translate }}</h3>
        <mat-card class="info-card">
          <mat-checkbox [checked]="!!currentItem.useWaterAndBiodeversityIndicators" disabled> {{ 'project_section_water_biodiversity' | translate }} </mat-checkbox>
        </mat-card>
      </div>
    </div>
  </div>

  <div class="title-margin-top">
    <h3>{{ 'project_section_project' | translate }}</h3>
    <mat-card class="info-card">
      <mat-grid-list cols="9" rowHeight="50px" gutterSize="20px">
        <mat-grid-tile colspan="3">
          <div class="info-field">
            <label class="info-label">{{ 'project_field_customer_ref' | translate }}</label>
            <p class="info-value">{{ currentItem.customerRef || '-' }}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="3">
          <div class="info-field">
            <label class="info-label">{{ 'project_field_title1' | translate }}</label>
            <p class="info-value">{{ currentItem.title1 || '-' }}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="3">
          <div class="info-field">
            <label class="info-label">{{ 'project_field_title2' | translate }}</label>
            <p class="info-value">{{ currentItem.title2 || '-' }}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="9">
          <div class="info-field">
            <label class="info-label">{{ 'common_field_description' | translate }}</label>
            <p class="info-value description">{{ currentItem.description || '-' }}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="3">
          <div class="info-field">
            <label class="info-label">{{ 'project_field_project_contractor' | translate }}</label>
            <p class="info-value">{{ currentItem.moa || '-' }}</p>
          </div>
        </mat-grid-tile>
        <mat-grid-tile colspan="3">
          <div class="info-field">
            <label class="info-label">{{ 'project_field_moa_complement' | translate }}</label>
            <p class="info-value">{{ currentItem.moaComplement || '-' }}</p>
          </div>
        </mat-grid-tile>
      </mat-grid-list>

      <div class="row logos-row" *ngIf="currentItem.workInspectionId">
        <div class="col-4 logo-container">
          <h4>{{ 'project_logo_contractor' | translate }}</h4>
          <div *ngIf="currentItem.projectLogo" class="logo">
            <img class="img-logo" alt="project-logo" [src]="wsAppPath + currentItem.projectLogo" />
          </div>
          <p *ngIf="!currentItem.projectLogo">{{ 'work_inspection_project_no_logo' | translate }}</p>
        </div>
        <div class="col-4 logo-container">
          <h4>{{ 'project_logo_customer' | translate }}</h4>
          <div *ngIf="currentItem.customerLogo" class="logo">
            <img class="img-logo" alt="customer-logo" [src]="wsAppPath + currentItem.customerLogo" />
          </div>
          <p *ngIf="!currentItem.customerLogo">{{ 'work_inspection_project_no_logo' | translate }}</p>
        </div>
      </div>
    </mat-card>
  </div>
</div>
